<template>
    <transition name="confirm-fade">
        <div v-if="isShowConfirm" class="my-confirm" @click.stop="hidden()">
            <div :class="['wrap', { 'container-dark': theme_dark }]" @click.stop>
                <h3 class="title">{{ titleText }}</h3>

                <div class="content">
                    <div class="txt ub ub-pc" v-html="content"></div>

                    <div class="oper ub ub-ac3">
                        <div v-if="type==='confirm'" class="btn cancel  ub ub-ac ub-pc" @click="clickFun('clickCancel')">
                            <span>{{ cancelText }}</span>
                        </div>
                        <div class="btn ok ub ub-ac ub-pc" @click="clickFun('clickConfirm')">
                            <span>{{ confirmText }}</span>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </transition>
</template>

<script >
import * as tool from '../api/common';
      export default {
        data () {
          return {
            isShowConfirm: false, // 用于控制整个窗口的显示/隐藏
            titleText: '操作提示', // 提示框标题
            content: 'Say Something ...', // 提示框的内容
            cancelText: '取消', // 取消按钮的文字
            confirmText: '确认', // 确认按钮的文字
            type: 'confirm', // 表明弹框的类型：confirm - 确认弹窗（有取消按钮）；alert - 通知弹框（没有取消按钮）
            outerData: null, // 用于记录外部传进来的数据，也可以给外部监听userBehavior，事件的函数提供判断到底是哪个事件触发的
            theme_dark: false
          }
        },
        methods: {
          show (content, config) {
            //切换深色模式
            this.theme_dark = tool.is_theme_dark(this);
            this.content = content || 'Say Something ...'
      
            if (Object.prototype.toString.call(config) === '[object Object]') {
              // 确保用户传递的是一个对象
              this.titleText = config.titleText || '操作提示'
              this.cancelText = config.cancelText || '取消'
              this.confirmText = config.confirmText || '确认'
              this.type = config.type || 'confirm'
              this.outerData = config.data || null
            }
      
            this.isShowConfirm = true;
          },
          hidden () {
            this.isShowConfirm = false
            this.titleText = '操作提示'
            this.cancelText = '取消'
            this.confirmText = '确认'
            this.type = 'confirm'
            this.outerData = null
          },
          clickFun (type) {
            this.$emit('formBehavior', type, this.outerData)
            this.hidden()
          }
        }
      }
      </script>

<style lang="scss" scoped>
    .my-confirm {
        position: fixed;
        top: 0;
        left: 0;
        width:100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 998;
        /* 这里防止当用户长按屏幕，出现的黑色背景色块，以及 iPhone 横平时字体的缩放问题 */
        -webkit-text-size-adjust: 100%;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    }

    /* 进入和出去的动画 */
    .confirm-fade-enter-active {
        animation: opacity 0.3s;
    }
    .confirm-fade-leave-active {
        animation: outOpacity 0.2s;
    }
     /* 进来的动画 */
    @keyframes opacity {
        0% {
            opacity: 0;
        }

        100% {
            opacity: 1;
        }
    }

    /* 出去的动画 */
    @keyframes outOpacity {
        0% {
            opacity: 1;
        }

        100% {
            opacity: 0;
        }
    }

    /* 包裹层容器样式 */
    .wrap {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate3d(-50%, -50%, 0);
        width: 85%;
        margin: 0 auto;
        z-index: 999;
        user-select: none;
        border-radius: 1rem;
        background: linear-gradient(to bottom, #FE9CC0, #fff 3rem);
    }

    /* 顶部标题部分 */
    .title {
        height: 3rem;
        line-height: 3rem;
        text-align: center;
        font-size: 1rem;
        font-weight: bold;
        color: #6C1AAB;
    }

    .content {
        padding: 0 0.8rem;
        /* 中间内容部分 */
        .txt {
            min-height: 3rem;
            word-break: break-word;
            line-height: 1.6rem;
            font-size: 0.9rem;
            color: #666;
        }
    }

    /* 底部按钮样式 */
    .oper {
        margin: 1.5rem 0;
        .btn {
            margin: 0 0.5rem;
            flex: 1;
            border-radius: 2rem;
        }
        .ok {
            background: linear-gradient( 90deg, #A264E7, #FE9CC0);
        }
        .cancel{
            color: #FFFFFF;
            background-color: #C1C1C1;
        }
        span {
            line-height: 2.6rem;
            color: #fff;
        }
    }

    .container-dark {
        background: linear-gradient(to bottom, #9c365c, #333 3rem);
        .title {
            color: #fff;
        }
        .content {
            .txt {
                color: #e0dbdb;
            }
        }
    }
</style>